export default {
  MES_REMUNERATIONS: {
    TITLE: 'Mes rémunérations',
    YEAR_LABEL: 'Année',
    NET_SALARY: 'Salaire net',
    EVOLUTION: 'Évolution',
    EVOLUTION_SUBTITLE: 'par rapport à l\'année dernière',
    OTHER_BENEFITS: 'Autres avantages',
    COMPANY_INVESTMENT: 'Investissement de l\'entreprise',
    BONUSES: 'Primes',
    EMPLOYER_CHARGES: 'Charges patronales',
    NO_DATA_FOR_YEAR: 'Aucune donnée disponible pour cette année',
    ERROR_LOADING_DATA: 'Erreur lors du chargement des données de rémunération',
    NO_BENEFITS_TITLE: 'Aucun avantage disponible',
    NO_BENEFITS_TEXT: 'Aucune donnée d\'avantages n\'a été enregistrée pour l\'année {{year}}. Les avantages seront affichés dès qu\'ils seront disponibles.',
  },
  GERER_REMUNERATIONS: {
    TITLE: 'Gérer les rémunérations',
    ADD_COLUMN: 'Ajouter une colonne',
    ADD_CATEGORY: 'Ajouter une catégorie',
    EDIT_COLUMN: 'Modifier la colonne',
    DELETE_COLUMN: 'Supprimer la colonne',
    SAVE_SUCCESS: 'Modifications enregistrées avec succès',
    SAVE_ERROR: 'Erreur lors de l\'enregistrement des modifications',
  },
  COLUMN_TYPES: {
    TEXT: 'Texte',
    NUMERIC: 'Numérique',
    DATE: 'Date',
  },
  MESSAGES: {
    COLUMN_CREATED: 'Colonne créée avec succès',
    COLUMN_UPDATED: 'Colonne mise à jour avec succès',
    COLUMN_DELETED: 'Colonne supprimée avec succès',
    CATEGORY_CREATED: 'Catégorie créée avec succès',
    CATEGORY_UPDATED: 'Catégorie mise à jour avec succès',
    VALUE_CREATED: 'Valeur créée avec succès',
    VALUE_UPDATED: 'Valeur mise à jour avec succès',
    VALUE_DELETED: 'Valeur supprimée avec succès',
  },
  CELL_CLEAR: {
    PROTECTED: 'Les valeurs historiques, liées à une source ou en lecture seule ne peuvent pas être effacées.',
    FORMULA_STORAGE_TYPE: 'La réinitialisation de cette formule nécessite un type numérique en base. Actualisez le tableau pour charger sa configuration actuelle.',
    DEPENDENT: 'Cette valeur intervient dans des calculs et ne peut pas être effacée. Zéro reste une valeur valide.',
    AMBIGUOUS: 'Cette cellule mensuelle contient des doublons, ou ses enregistrements ne correspondent pas à la période sélectionnée.',
    NO_OVERRIDE: 'Aucune valeur forcée enregistrée à supprimer. La valeur calculée est conservée.',
    PENDING_EDITS: 'Enregistrez ou annulez les autres modifications avant de réinitialiser une valeur calculée.',
    INVALID_FORMULA: 'La formule ne peut pas être calculée de manière fiable. La valeur enregistrée a été conservée.',
    RESET_REFRESH_ERROR: 'La valeur forcée a été supprimée, mais le tableau n’a pas pu être actualisé. Actualisez-le pour vérifier la valeur calculée.',
    UNAVAILABLE: 'L’effacement est indisponible pour cette valeur. Actualisez la page ou vérifiez la version du serveur.',
    BUSY: 'Veuillez attendre la fin de l’enregistrement en cours avant d’effacer une valeur.',
    INVALID_INPUT: 'Saisissez une valeur valide ou videz complètement le champ.',
    ERROR: 'La valeur n’a pas pu être effacée. La valeur précédente a été conservée.',
  },
  AUTOSAVE: {
    NO_CHANGES: 'Aucune modification à enregistrer',
    SAVE_SUCCESS: '{{count}} valeur(s) enregistrée(s) avec succès',
    SAVE_ERROR: 'Erreur lors de l\'enregistrement. Les valeurs non enregistrées ont été conservées.',
    IN_PROGRESS: 'Un enregistrement automatique est en cours. Veuillez patienter avant de quitter cette page.',
    SAVING: 'Enregistrement...',
    SAVED: 'Enregistré automatiquement',
    REFRESH_ERROR: 'La valeur a été enregistrée, mais le tableau n\'a pas pu être synchronisé. Actualisez la page pour la vérifier.',
    CALCULATED_SAVE_ERROR: 'Certains résultats calculés n’ont pas pu être enregistrés pour l’historique. Les calculs affichés restent inchangés. Actualisez la page pour réessayer.',
  },
  COLUMN_SEARCH: {
    PLACEHOLDER: 'Rechercher une colonne...',
    NO_RESULTS: 'Aucune colonne correspondante.',
  },
  SUMMARY_BADGE: {
    SUM: 'Somme',
    AVERAGE: 'Moyenne',
    HIDDEN: 'Caché',
    HELP: 'Les indicateurs affichent les calculs automatiques enregistrés pour l’onglet sélectionné, ou l’onglet courant par défaut.',
  },
  SUMMARY_YEAR: {
    TITLE: 'Tableau de synthèse vert',
    SCOPE_HELP: 'Configurez les totaux et moyennes pour l’onglet sélectionné. Les années variables modifient uniquement les libellés, pas les calculs ni les données sources.',
    SAVE_ERROR: 'La colonne existe, mais ses paramètres de synthèse n’ont pas pu être enregistrés. Réessayez d’enregistrer les paramètres.',
  },
  SYNTHESIS: {
    TITLE: 'Synthèse de la rémunération',
    UPDATE_DATE: 'Date de mise à jour',
    PERSONAL_DATA: 'Données personnelles',
    ASSIGNMENT_DATA: 'Données d\'affectation',
    CONTRACT_DATA: 'Données contrat',
    MATRICULE: 'Matricule',
    NAME: 'Nom et prénom',
    BIRTH_DATE: 'Date de naissance',
    GENDER: 'Sexe',
    DEPARTMENT: 'Département',
    POSITION: 'Post',
    MANAGER: 'Manager hiérarchique',
    COUNTRY: 'Pays',
    SITE: 'Site',
    COMPANY: 'Société',
    COMPANY_ENTRY_DATE: 'Date d\'entrée société',
    GROUP_ENTRY_DATE: 'Date d\'entrée groupe',
    CONTRACT_TYPE: 'Type de contrat',
    FIXED_REMUNERATION: 'Rémunération fixe',
    CAMPAIGN_ATTRIBUTES: 'Attributs de campagne',
    VARIABLE_ELEMENTS: 'Éléments variables',
    DATE: 'Date',
    REASON: 'Motif',
    TYPE: 'Type de rem',
    LEVEL: 'Niveau',
    FIXED_SALARY: 'Salaire fixe',
    INCREASE_AMOUNT: 'Montant d\'augmentation',
    PERCENTAGE: '%',
    BASE_SALARY: 'Salaire de base',
    TOTAL: 'TOTALE',
    NO_DATA: 'Aucune donnée disponible',
    CLOSE: 'Fermer',
  },
  REPORTING: {
    TITLE: 'Tableau de bord - Reporting',
    PERIOD: 'Période',
    MONTHLY_VIEW: 'Vue mensuelle',
    YEARLY_VIEW: 'Vue annuelle',
    FILTER_SUPER_CATEGORY: 'Filtrer par super catégorie',
    FILTER_CATEGORY: 'Filtrer par catégorie',
    ALL_SUPER_CATEGORIES: 'Toutes les super catégories',
    ALL_CATEGORIES: 'Toutes les catégories',
    TOTAL_EMPLOYEES: 'Collaborateurs',
    TOTAL_KPIS: 'KPIs',
    CATEGORIES: 'Catégories',
    COLUMNS: 'Colonnes',
    KPIS_BY_CATEGORY: 'KPIs par catégorie',
    NO_DATA: 'Aucune donnée disponible pour générer des KPIs',
    EXPORT_EXCEL: 'Exporter vers Excel',
    SIMULATION_MODE: 'Mode Simulation',
    SIMULATION_MODE_DESC: 'Les KPIs se mettent à jour automatiquement lorsque vous modifiez des valeurs dans le tableau, sans nécessiter de sauvegarde.',
  },
  SETTINGS: {
    TITLE: 'Paramètres de rémunération',
    DESCRIPTION: 'Gérez les paramètres et les accès pour le module de rémunération',
    VISIBILITY_SETTINGS: 'Paramètres de visibilité',
    VISIBLE_COLLABORATEUR: 'Visible par les collaborateurs',
    VISIBLE_COLLABORATEUR_DESC: 'Les collaborateurs peuvent voir leurs propres données de rémunération',
    VISIBLE_MANAGER: 'Visible par les managers',
    VISIBLE_MANAGER_DESC: 'Les managers peuvent voir les données de rémunération de leurs équipes',
    HIDE_MONTHLY_VIEW_MANAGER: 'Masquer la vue mensuelle pour les managers paie',
    HIDE_MONTHLY_VIEW_MANAGER_DESC: 'Les managers paie ne pourront accéder qu\'à la vue annuelle',
    MONTHLY_VIEW_HIDDEN_FOR_MANAGER: 'Vue mensuelle masquée pour les managers paie',
    MONTHLY_VIEW_VISIBLE_FOR_MANAGER: 'Vue mensuelle visible pour les managers paie',
    ADMIN_PAIES: 'Administrateurs paie',
    SELECT_USER_ADMIN: 'Sélectionner un utilisateur',
    ADD_ADMIN: 'Ajouter admin',
    ADMIN_ADDED: 'Administrateur paie ajouté avec succès',
    ADMIN_REMOVED: 'Administrateur paie retiré avec succès',
    NO_ADMIN_PAIES: 'Aucun administrateur paie configuré',
    CONFIRM_REMOVE_ADMIN: 'Confirmer la suppression',
    CONFIRM_REMOVE_ADMIN_DESC: 'Êtes-vous sûr de vouloir retirer cet utilisateur en tant qu\'administrateur paie ?',
    CHOOSE_USER: 'Choisir un utilisateur',
    SELECT_USER: 'Veuillez sélectionner un utilisateur',
    CONTRACT_VISIBILITY: 'Contrats visibles',
    CONTRACT_VISIBILITY_DESC: 'Sélectionnez les types de contrats qui seront visibles dans la gestion des rémunérations',
    NO_CONTRACTS: 'Aucun contrat disponible',
    CONTRACTS_SELECTED: 'contrat(s) sélectionné(s)',
    DEFAULT_YEAR_MANAGER: 'Année par défaut pour les managers',
    DEFAULT_YEAR_MANAGER_DESC: 'L\'année qui sera affichée par défaut lorsque les managers accèdent à la gestion des rémunérations',
    DEFAULT_YEAR_UPDATED: 'Année par défaut mise à jour avec succès',
    EXCLUDED_USERS_TITLE: 'Collaborateurs exclus',
    EXCLUDED_USERS_DESC: 'Sélectionnez les collaborateurs qui ne doivent pas apparaître dans les tableaux de rémunération.',
    EXCLUDED_USERS_PLACEHOLDER: 'Rechercher par nom, équipe, site…',
    EXCLUDED_USERS_EMPTY: 'Aucun collaborateur ne correspond à vos filtres.',
    EXCLUDED_USERS_SELECTED: 'collaborateur(s) exclu(s)',
    EXCLUDED_USERS_UPDATED: 'Collaborateurs exclus mis à jour avec succès',
    EXCLUDED_USERS_SELECTED_LIST: 'Collaborateurs exclus',
    MANAGE_EXCLUDED_USERS: 'Gérer les collaborateurs exclus',
  },
  ONGLETS: {
    TITLE: 'Gestion des onglets',
    BTN_ADD: 'Ajouter un onglet',
    ADD_NEW: 'Nouvel onglet',
    LABEL: 'Libellé',
    ORDER: 'Ordre',
    VISIBLE_MANAGER: 'Visible manager',
    VISIBLE_MANAGER_HELP: 'Cet onglet sera visible pour les managers paie',
    PLACEHOLDER_LABEL: 'Entrez le libellé de l\'onglet',
    NO_ONGLETS: 'Aucun onglet configuré',
    WARNING_ADMIN_ONLY: 'Seuls les administrateurs paie peuvent gérer les onglets',
    ERROR_NOT_ADMIN: 'Accès refusé : vous devez être administrateur paie',
    ERROR_LOAD: 'Erreur lors du chargement des onglets',
    ERROR_CREATE: 'Erreur lors de la création de l\'onglet',
    ERROR_UPDATE: 'Erreur lors de la mise à jour de l\'onglet',
    ERROR_DELETE: 'Erreur lors de la suppression de l\'onglet',
    ERROR_EMPTY_LABEL: 'Le libellé ne peut pas être vide',
    SUCCESS_CREATE: 'Onglet créé avec succès',
    SUCCESS_UPDATE: 'Onglet mis à jour avec succès',
    SUCCESS_DELETE: 'Onglet supprimé avec succès',
    CONFIRM_DELETE: 'Êtes-vous sûr de vouloir supprimer l\'onglet "{{label}}" ?',
  }
};
